import gql from "graphql-tag";

export const MY_LEAVE_GET_LEAVES_BY_CONTRACT = gql`
  query leavesByContract($contract: String!, $year: Int!) {
    leavesByContract(contract: $contract, year: $year) {
      year
      startDate
      endDate
      workDays
      effectiveWorkDays
      name
      type
      sourcekey
      _id
    }
  }
`;
